<template>
  <div class="bg-theme-100 rounded-sm flex items-center text-white font-poppins">
    <button
      class="p-3 group transition-opacity duration-300 ease-smooth hover:opacity-70 hover:cursor-pointer disabled:opacity-50"
      :disabled="model === 0"
      aria-label="Vorige locatie"
      @click="model--">
      <ChevronLeftIcon class="w-4 h-4 transition-transform duration-300 ease-smooth group-hover:-translate-x-0.5" />
    </button>
    <Typography as="div" variant="body" class="min-w-16 text-center">
      {{ model + 1 }} van {{ marker.locations.length }}
    </Typography>
    <button
      class="p-3 group transition-opacity duration-300 ease-smooth hover:opacity-70 hover:cursor-pointer disabled:opacity-50"
      :disabled="model === marker.locations.length - 1"
      aria-label="Volgende locatie"
      @click="model++">
      <ChevronRightIcon class="w-4 h-4 transition-transform duration-300 ease-smooth group-hover:translate-x-0.5" />
    </button>
  </div>
</template>

<script lang="ts" setup>
import { ChevronLeftIcon, ChevronRightIcon } from '@gro-up/ui/icons'
import { Typography } from '@gro-up/ui/primitives'

import type { LocationMarker } from './MapMarker.vue'

const model = defineModel<number>({ default: 0 })

defineProps<{
  marker: LocationMarker
}>()
</script>
